import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";

function AccordionMenu({
    section,
    customContainerClass,
    customAccordionContainer,
    customAccordionHeader,
    customAccordionCollapse,
}: any) {
    const [activeKey, setActiveKey] = useState(section?.activeKey || "1");
    const KEY = ["1", "0"];
    const handleAccordionClick = () => {
        setActiveKey((preActive: any) => KEY[preActive]);
    };

    return (
        <div
            className={
                customContainerClass ? customContainerClass : "container"
            }
        >
            <Accordion activeKey={"0"} className={customAccordionContainer}>
                <Card>
                    <div className={customAccordionHeader}>
                        <Accordion.Toggle
                            as={Button}
                            variant="link"
                            eventKey={activeKey}
                            onClick={() => handleAccordionClick()}
                        >
                            {section.title}
                        </Accordion.Toggle>
                        {section.header}
                    </div>
                    <Accordion.Collapse
                        eventKey={activeKey}
                        className={customAccordionCollapse}
                    >
                        <div>{section.content}</div>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    );
}

export default AccordionMenu;
